module.exports = __webpack_public_path__ + "img/team-2.be997d52.jpg";